import {ActionHandlerBase} from "../action-handler-base";

export class LogoutActionHandler extends ActionHandlerBase {
    async handle(): Promise<void> {
        this.services.user.logout();
    }
}
